import script from "./UpgradeToAccessNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeToAccessNotification.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeToAccessNotification.vue?vue&type=style&index=0&id=27fab4fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fab4fe"]])

export default __exports__